// extracted by mini-css-extract-plugin
export default {"loginLink":"u2HY3D","success":"DliEri","error":"iU0p_s","captchaError":"gAGigY","slider":"OvKQyS","form":"qSrE3K","lastLine":"OiYUoD"};